import { Pipe } from '@angular/core';
var IsNotIdenticalToPipe = (function () {
    function IsNotIdenticalToPipe() {
    }
    IsNotIdenticalToPipe.prototype.transform = function (input, other) {
        return input !== other;
    };
    IsNotIdenticalToPipe.decorators = [
        { type: Pipe, args: [{ name: 'isNotIdenticalTo' },] },
    ];
    /** @nocollapse */
    IsNotIdenticalToPipe.ctorParameters = function () { return []; };
    return IsNotIdenticalToPipe;
}());
export { IsNotIdenticalToPipe };
//# sourceMappingURL=is-not-identical-to.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-not-identical-to.js
// module id = 250
// module chunks = 4